import { Component, OnInit, Input } from '@angular/core';
import * as _ from "lodash";

@Component({
    selector: 'gaweb-steps-indicator',
    template: `
  <section>
    <div class="row steps-indicator" >
      <div class="steps" [ngClass]="'size-'+size">
          <div *ngFor="let s of steps" class="step" [ngClass]="{ 'complete': s.isCompleted, 'active': s.isActive }">
            <i *ngIf="s.isCompleted" class="fa fa-check"></i>
            <span *ngIf="!s.isCompleted">{{s.index}}</span>
          </div>
      </div>
    </div>
  </section>
  `,
    styles: [`
    .steps-indicator{

    }
  `]
})
export class StepsIndicatorComponent implements OnInit {
    @Input() size: number;
    @Input() active: number;
    steps: Array<Step>;

    constructor() { }

    ngOnInit() {
        this.steps = _.map(_.range(0, this.size), idx => new Step(idx + 1, (idx + 1) == this.active, (idx + 1) < this.active));
    }

}

export class Step {
    constructor(private index: number, private isActive: boolean, private isCompleted: boolean) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/steps-indicator/steps-indicator.component.ts